import React, { useEffect } from "react";
import { Button, Form, FormGroup, Label, Input, Container } from "reactstrap";
import AnimationCommon from "../common/AnimationCommon";
import { FaEnvelope, FaLock, FaPhone, FaUser } from "react-icons/fa";
import { Link } from "react-router-dom";

const SignUp = () => {
  useEffect(() => {
    document.body.classList.remove("inner-page");
  }, []);

  return (
    <section className='auth-page'>
      <AnimationCommon />
      <Container className='auth-card'>
        <div className='text-center'>
          <h2>Sign Up</h2>
          <img src='assets/images/title-line.png' alt='title-line' className='img-fluid line' />
          <p>Welcome To chatloop, Please Sign up With Your Personal Account Information.</p>
        </div>
        <div className='main'>
          <Form className='auth-form'>
            <FormGroup className='form-group'>
              <Label>Name</Label>
              <FaUser className="icon-setting"/>
              <Input required name='loginname' type='text' placeholder='Name' />
            </FormGroup>
            <FormGroup className='form-group'>
              <Label>Phone no</Label>
              <FaPhone className="icon-setting"/>
              <Input required name='loginnumber' type='text' placeholder='Phone no.' />
            </FormGroup>
            <FormGroup className='form-group'>
              <Label>Email</Label>
              <FaEnvelope className="icon-setting"/>
              <Input required name='login[username]' type='email' placeholder='Email' />
            </FormGroup>
            <FormGroup className='form-group'>
              <Label>Password</Label>
              <FaLock className="icon-setting"/>
              <Input id='exampleInputPassword1' required name='login[password]' type='password' placeholder='Password' />
              <Link to={`${process.env.PUBLIC_URL}/forget-password`} className='forgot-pass text-decoration-none'>forgot?</Link>
            </FormGroup>
            <FormGroup>
              <Button className='submit' color='primary'>Sign Up</Button>
            </FormGroup>
            <div className='or-saparator'>
              <span>or</span>
            </div>
            <h6 className='text-center mt-0 mb-3'>Sign in with:</h6>
            <div className='form-button d-sm-flex justify-content-center align-items-center text-center social-btns'>
              <Button className='submit fb' color='primary'>Facebook</Button>
              <Button className='submit ggl' color='danger'>Google</Button>
            </div>
          </Form>
        </div>
      </Container>
    </section>
  );
};

export default SignUp;
